import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TutorialService {

  constructor() { }

  private readonly TUTORIAL_KEY = 'tutorial_completed';

  isTutorialCompleted(): boolean {
    return localStorage.getItem(this.TUTORIAL_KEY) === 'true';
  }

  setTutorialCompleted(): void {
    localStorage.setItem(this.TUTORIAL_KEY, 'true');
  }
}
